(function () {
  const timelineBlocks = document.querySelectorAll('.timeline--timeline-block');
  const windowHeight = window.innerHeight;

  window.addEventListener('scroll', function () {
    const scrollPos = window.scrollY;

    for (let block of timelineBlocks) {
      if (block.offsetTop <= scrollPos + (windowHeight / 2)) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    }
  })
})();